/**
 * Different modes of the Dermlite.
 */
export enum DermliteMode {
  NonPolarised = 0,
  Polarised = 1,
  PoweredOff = 2,
}
